<div class="ex-exercise__modal">
  <div class="ex-exercise__modal_header">
      <div class='modal-close' (click)='close()'>
          <app-svg-icon [src]="closeIcon"></app-svg-icon>
      </div>
  </div>
  <div class="ex-exercise__modal_body">
      <div class="ex-exercise__modal_body__title">
        <div class="ex-exercise__modal_body__title_main"><i>Дополнительное задание:</i></div>
        <div class="ex-exercise__modal_body__title_ex">
          <i>{{ exExercise.title }}</i>
        </div>
      </div>
      <div class="ex-exercise__modal_body__reward">
          <span class="ex-exercise__modal_body__reward_left">
              <button (click)="onSubmit(true, 'cash_reward')">
                <span>
                    наличными
                    <p class="reward-count">+ {{ exExercise.reward }}
                    <small class="reward-word"> 
                        {{ declensionOfNumerals(exExercise.reward) }}
                    </small></p>
                </span>
                <span class="icon">
                  <img src="/assets/images/icons/smile_good.png" alt="">
                </span>
              </button>
          </span>
          <span class="ex-exercise__modal_body__reward_pupil">
            <div>
                <img src="{{ MAIN_DOMAIN }}{{ pupil.photo_url }}" alt=""/>
            </div>
          </span>
          <span class="ex-exercise__modal_body__reward_right">
              <button (click)="onSubmit(true, 'bank_reward')">
                <span class="icon">
                  <img src="/assets/images/icons/smile_good.png" alt="">
                </span>
                <span>
                    на счет
                    <p class="reward-count">+ {{ exExercise.reward }}
                    <small class="reward-word"> 
                        {{ declensionOfNumerals(exExercise.reward) }}
                    </small></p> 
                </span>
              </button>
          </span>
      </div>
      <div class="ex-exercise__modal_body__smile-bad" (click)="onSubmit(false)">
        <span class="ex-exercise__modal_body__smile-bad_icon">
            <img src="/assets/images/icons/smile_bad.png" alt="">
        </span>
        <span class="ex-exercise__modal_body__smile-bad_title">
          Что-то не так
        </span>
      </div>
  </div>
</div>
    